import { useReduxDispatch, useReduxSelector } from 'store'
import VerificationPopup from './auth/VerificationPopup'
import useRestPopupState from 'hooks/useRestPopupState'
import { selectRest, showPopup } from 'rest/restSlice'
import { POPUPS as HomePopups } from 'containers/Home'
import { UNAUTHORIZED_TYPES } from 'utils/constants'
import { checkIsNativeApp } from 'utils/nativeApp'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import AuthPopup from './auth/BiometricPopup'
import Popup from 'components/popups/Popup'
import React, { useEffect } from 'react'
import NewMagPopup from './NewMagPopup'
import OtpPopup from './auth/OtpPopup'
import PinPopup from './auth/PinPopup'
import ErrorPopup from './ErrorPopup'
import NativeAuth from './NativeAuth'

const isNativeApp = checkIsNativeApp()
const Popups: React.FC = () => {
  return (
    <div className='popups'>
      <BasicPopups />
      <RestPopups />
    </div>
  )
}

const BasicPopups: React.FC = () => {
  const { popup } = usePopupState()
  const { t } = useTranslation('home')

  switch (popup) {
    case 'newMag': return <NewMagPopup />
    case HomePopups.invest: return (
      <Popup>
        <div className='popup__title'>
          <i className='icon icon--logo s24' />
          <div>{t('comingSoon')}</div>
          <div>{t('youWillBeAbleToStartEarningWithUs')}</div>
        </div>
      </Popup>
    )

    case HomePopups.magStore: return (
      <Popup>
        <div className='popup__title'>
          <i className='icon icon--logo s24' />
          <div>{t('comingSoon')}</div>
          <div>{t('youWillBeAbleToGetRidOfUnnecessaryThingsFromYourApartment')}</div>
        </div>
      </Popup>
    )

    case HomePopups.magMobile: return (
      <Popup>
        <div className='popup__title'>
          <i className='icon icon--logo s24' />
          <div>{t('comingSoon')}</div>
          <div>{t('youWillBeAbleToRentAWarehouse')}</div>
        </div>

        <div className='popup__list'>
          <div className='list__title'>{t('allYouNeedToDoIs')}</div>
          <ul>
            <li>{t('youWillChooseThePeriodOfTimeDuringWhichYouWantTheWarehouseToRemainWithYou')}</li>
            <li>{t('youTellUsTheAddressWhereItShouldBeDelivered')}</li>
          </ul>
        </div>
      </Popup>
    )

    default: return null
  }
}

const RestPopups: React.FC = () => {
  const { isPopup, popupBody } = useReduxSelector(selectRest)
  const isPopupVisible = useRestPopupState(popupBody?.type)
  const dispatch = useReduxDispatch()

  useEffect(() => {
    if (isPopup) {
      const onPopState = () => { dispatch(showPopup()) }
      window.addEventListener('popstate', onPopState)
      return () => { window.addEventListener('popstate', onPopState) }
    }
  }, [dispatch, isPopup])

  if (isPopupVisible) {
    if (isNativeApp && (popupBody?.type === UNAUTHORIZED_TYPES.webAuth)) return <NativeAuth />
    return <Popup isPopup={isPopup}>
      {(() => {
        switch (popupBody?.type) {
          case UNAUTHORIZED_TYPES.mail:
          case UNAUTHORIZED_TYPES.phone:
          case UNAUTHORIZED_TYPES.device: return <VerificationPopup />
          case UNAUTHORIZED_TYPES.mailOtp:
          case UNAUTHORIZED_TYPES.smsOtp: return <OtpPopup />
          case UNAUTHORIZED_TYPES.webAuth: return <AuthPopup />
          case UNAUTHORIZED_TYPES.pin: return <PinPopup />
          case 'formError': return <ErrorPopup />
          default: return null
        }
      })()}
    </Popup>
  }

  return null
}

export default Popups